import { PublicWebRedirect } from '@/features/public-web/PublicWebRedirect';
import { APP_CONFIG } from '@/lib/app/config';

export default function PrivacyWebScreen() {
  return <PublicWebRedirect label="Privacy Policy" targetURL={APP_CONFIG.privacyPolicyURL} />;
}
